import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs";
import {contextPath} from "site";
import {OrgService} from "../shared/org.service";
import {RedemptionOptions, RedemptionSelection} from "./redemption-options";

const apiURL = `${contextPath}/api/redeem-bundle/`;
const apiCouponURL = `${apiURL}validate-coupon/`;

@Injectable()
export class RedemptionService {
	constructor(
		private http: Http,
		private orgService: OrgService
		) {
	}

	getRedemptionOptions(deviceID: string, partKey?: string, couponCode?: string): Observable<RedemptionOptions> {
		let params: {[key: string]: any} = {deviceID};
		if (partKey) {
			params.partKey = partKey;
		}
		if (couponCode) {
			params.couponCode = couponCode;
		}

		return this.http.get(apiURL, {params, headers: this.orgService.contextHeader})
			.map(response => RedemptionOptions.fromJSON(response.json()));
	}

	redeemSelection(selection: RedemptionSelection) {
		// filter out nulls;
		selection.deviceSelection = selection.deviceSelection
			.filter(deviceSelection => deviceSelection);
		selection.deviceSelection.map(deviceSelection => {
				deviceSelection.groupSelection = deviceSelection.groupSelection.filter(value => value);
				return deviceSelection;
			});

		return this.http.post(apiURL, selection, {headers: this.orgService.contextHeader});
	}

	verifyCoupon(couponCode: string, deviceId?: number) {
		let params: {[key: string]: any} = {couponCode};
		if (deviceId) {
			params.deviceId = deviceId;
		}
		return this.http.get(apiCouponURL, {params, headers: this.orgService.contextHeader});
	}
}
